import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { Ptag } from "components/core/fonts";
import ECard from "./ECard";
import { ECardHeader, ECardLink, ECardScroll, Line } from "./styles";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ECardPdf from "components/ECardPdf";
import { FLEX_PRODUCTS } from "pages/FlexSetup/constants";
import http from "services/httpService";


const ECardList = ({ abbr, members }) => {
  const sortedMembers = members.sort((a, b) => {
    if (a.relationship === "SELF") return -1; // Move "SELF" to the first
    if (b.relationship === "SELF") return 1;  // Move others down
    return 0; // No change for other relationships
  });
  const navigate = useNavigate();
  // getting title based on the abbreviation
  const title = useMemo(() => {
    let title = "";
    FLEX_PRODUCTS.find((product) => {
      if (product.value === abbr) {
        title = product.display_name;
        return title;
      }
    });
    switch (abbr) {
      case "GMC":
      case "GMC_M":
        title = "Group Mediclaim Cover";
        break;
      case "GPA":
        title = "Group Personal Accident";
        break;
      case "GTL":
        title = "Group Term Life";
        break;
    }
    return title;
  }, [abbr]);

  const getProductCommercialAbbr = () => {
    switch (abbr) {
      case "GMC":
      case "GMC_M":
        return "GHI";
      default:
        return abbr;
    }
  };

  const ecardDownloadHandler = async (vitalCoverId) => {
    try {
      const { data } = await http.post(
        `business/download_e_card/?vital_cover_id=${vitalCoverId}`,
      );
      return data;
    } catch (error) {
      console.log("# E card Download failure:", error);
      return false;
    }
  };

  const handleECardDownload = async (event) => {

    // Using single Vital Cover id as it is same for the self and dependents
    // for the single product (like GMC, GPA, etc.)
    let getSingleMemberVitalCoverId = members[0].vital_cover_id;
    const eCardResponse = await ecardDownloadHandler(
      getSingleMemberVitalCoverId,
    );

    if (eCardResponse) {
      event.preventDefault();
      console.log("# Downloading TPA Level E-Cards.");
      // window.open(eCardResponse.e_card_download, "_blank");

      if (eCardResponse && eCardResponse.e_card_download) {
        try {
          // Create a hidden link
          const link = document.createElement("a");
          link.href = eCardResponse.e_card_download;

          // This attribute is often ignored across different domains,
          // but it's the only way without a proxy or fetch.
          link.setAttribute("download", "ECard.pdf");
          link.setAttribute("target", "_blank");

          document.body.appendChild(link);
          link.click();
          link.remove();
        } catch (err) {
          console.error(
            "Manual download failed, falling back to PDFDownloadLink logic",
            err,
          );
        }
      }

      return;
    } else {
      console.log("# Downloading Neo Level E-Cards.");
      return;
    }
  };

  return (
    <ECardScroll>
      <ECardHeader>
        <Ptag marginLeft="1rem" fontSize="20px" fontWeight="600">
          {title}
        </Ptag>
        <PDFDownloadLink
          document={<ECardPdf members={members} />}
          fileName={`${getProductCommercialAbbr()}_E_Cards.pdf`}
          onClick={handleECardDownload}
        >
          <ECardLink>Download E-Cards</ECardLink>
        </PDFDownloadLink>
      </ECardHeader>
      <Line />
      <div
        style={{
          marginTop: "2.2rem",
          display: "flex",
          overflow: "auto",
          gap: "2.4rem",
          padding: "2rem 1rem",
        }}
      >
        {sortedMembers.map((member, index) => (
          <ECard key={index.toString()} member={member} />
        ))}
      </div>
    </ECardScroll>
  );
};

export default ECardList;
